function getQueryData(query:object):Array<{key:any, value: any}> {
    return Object.entries(query).map((item: any) => {
        return {
            key: item[0],
            value: item[1]
        }
    })
}
export default getQueryData;